import React from 'react';
export function Hero() {
  return <div className="w-full py-6 md:py-10" data-id="element-306">
      <div className="max-w-3xl mx-auto text-center mb-6" data-id="element-307">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-5 leading-tight" data-id="element-308">
          Your <span className="text-red-600" data-id="element-309">Anxiety</span>,{' '}
          <span className="text-red-600" data-id="element-310">Fatigue</span> &{' '}
          <span className="text-red-600" data-id="element-311">Burnout</span> Are Not All in Your Head
          — They Live in Your Nervous System.
        </h1>
        <h2 className="text-xl md:text-2xl text-gray-700 mb-6 leading-relaxed" data-id="element-312">
          Discover the gentle daily practice that finally helped me stop the
          spirals, calm my fear, and feel safe in my body again — even after
          years of spiraling anxiety.
        </h2>
        <div className="w-full my-6" data-id="element-313">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/x3Bnjj4DTzSCCNWPm5jrLr/488007648_973055568144647_6503679057397182315_n_%281%29.jpg" alt="Vagus nerve diagram showing connection to anxiety and sleep issues" className="w-full max-w-2xl mx-auto h-auto object-contain rounded-lg shadow-md" data-id="element-314" />
        </div>
        <div className="flex flex-col md:flex-row items-center gap-6 bg-gray-50 p-6 rounded-lg shadow-sm mb-8" data-id="element-315">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/j5zTyzAgttUCqoETGdVR5z/a72d7f-b65f-f3f-db31-1bd8fccf7dda_b5678e5b-b47a-449f-a3a7-7890b1473025_%282%29.webp" alt="Dr. Kim DiRé headshot" className="w-32 h-32 rounded-full object-cover shadow-md" data-id="element-316" />
          <p className="text-gray-700 text-left" data-id="element-317">
            <span className="font-semibold" data-id="element-318">Dr. Kim DiRé</span> is a trauma
            therapist and somatic healing expert specializing in nervous system
            regulation.
          </p>
        </div>
        <div className="text-left mt-6" data-id="element-319">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-320">
            Your body isn't broken—it's trying to protect you.
          </h2>
          <p className="text-gray-700 mb-4" data-id="element-321">
            If there's one message I wish I could give every person who's ever
            sat across from me—tired, foggy, overwhelmed, and frustrated… It's
            that.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-322">
            And the way you feel right now… it's not your fault.
          </p>
          <p className="font-bold text-gray-800 mb-4" data-id="element-323">
            Over the last 25 years, I've worked with thousands of clients…
          </p>
          <p className="text-gray-700 mb-4" data-id="element-324">
            Many of them were high-achieving, self-aware, deeply thoughtful
            people who were quietly falling apart inside.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-325">
            They had already done everything "right."
          </p>
          <p className="text-gray-700 mb-4" data-id="element-326">
            They ate well. They exercised. They journaled. They meditated. Some
            had spent years in therapy.
          </p>
        </div>
      </div>
    </div>;
}